import React from "react";
import parseNumber from "../../../../utils/parseCalculate";
import { useLiveDevice } from "../../../../hooks/useLiveDeviceData";
import { WifiIcon } from "../../../icons/StatusIcons";

const RadioCard = ({
  name,
  date,
  radioName,
  radioId,
  onClick,
  checked,
  deviceType,
}) => {
  const { data, units, status: deviceStatus } = useLiveDevice(radioId, {
    watchStatus: true,
  });
  const deviceDetail = {
    flowrate: parseNumber(data?.flowrate),
    level: parseNumber(data?.level),
    totalizer: parseNumber(data?.totalizer),
    cod: parseNumber(data?.cod),
    bod: parseNumber(data?.bod),
    tss: parseNumber(data?.tss),
    ph: parseNumber(data?.ph),
    temp: parseNumber(data?.temp),
    flow_unit: units.flow_unit,
    level_unit: units.level_unit,
    total_unit: units.total_unit,
  };

  return (
    <>
      <button
        className="fluid-wrap radio-card"
        htmlFor={radioId}
        onClick={onClick}
      >
        <div className="item1 d-flex align-items-center">
          <input
            type="radio"
            name={radioName}
            id={radioId}
            hidden
            className="chart-radio-btn"
            checked={checked}
          />
          <div className="radio-btn-wrap">
            <div className="radio-btn"></div>
          </div>
          <div className="fluid-detail">
            <h5 className="fluid-name">{name}</h5>
            <p className="subscription-detail">Subscription End: {date}</p>
          </div>
        </div>

        <div className="item2 d-flex align-items-center justify-content-evenly justify-md-content-between">
          <div className="current-flow-info">
            <h5 className="flow-num">
              {deviceType === "flow"
                ? deviceDetail?.flowrate
                : deviceType === "level"
                ? deviceDetail?.level
                : deviceDetail?.cod}
            </h5>
            <p className="flow-type">
              {deviceType === "flow"
                ? "Current Flow"
                : deviceType === "level"
                ? "Level"
                : "COD"}
            </p>
            <p className="unit">
              (
              {deviceType === "flow"
                ? deviceDetail?.flow_unit
                : deviceType === "level"
                ? deviceDetail?.level_unit
                : "mg/L"}
              )
            </p>
          </div>

          <div className="current-flow-info">
            {deviceType === "flow" && (
              <>
                <h5 className="flow-num">{deviceDetail?.totalizer}</h5>
                <p className="flow-type">total flow</p>
                <p className="unit">({deviceDetail?.total_unit})</p>
              </>
            )}
            {deviceType === "water_quality" && (
              <>
                <h5 className="flow-num">{deviceDetail?.ph}</h5>
                <p className="flow-type">pH</p>
                <p className="unit">(pH)</p>
              </>
            )}
          </div>
        </div>

        <div className="item3 other-info d-flex align-items-center">
          <div className="fluid-status me-4">
            <WifiIcon connected={deviceStatus === "active"} />
          </div>
        </div>
      </button>
    </>
  );
};

export default RadioCard;
